class WholesaleRegistration {
	form;
	conditionalFields;
	companyTypeField
	engineerFields;
	sampleBoxField;
	sampleBoxFields;

	/**
	 * Instantiate class.
	 */
	constructor( form ) {
		this.form = form;
		this.conditionalFields = form.querySelectorAll( '.form-row.is-conditional' );
		this.companyTypeField = form.querySelector( '[name="type"]' );
		this.engineerFields = form.querySelectorAll( '.form-row.if-engineer' );
		this.sampleBoxField = form.querySelector( '[name="order_sample_box"]' );
		this.sampleBoxFields = form.querySelectorAll( '.form-row.if-sample-box' );
		
		// Hide all conditional fields on load
		this.conditionalFields.forEach( field => field.hidden = true );
		
		// Set conditional fields on load
		this.handleAllFieldsVisibility();
		
		// Set conditional fields on change
		this.companyTypeField.addEventListener( 'change', () => { this.handleAllFieldsVisibility() } );
		this.sampleBoxField.addEventListener( 'change', () => { this.handleAllFieldsVisibility() } );
	}

	/**
	 * Set visibility of all fields.
	 */
	handleAllFieldsVisibility() {
		this.handleCompanyTypeFieldVisibility();
		this.handleSampleBoxFieldVisibility();
	}

	/**
	 * Set visibility when the Company Type field changes.
	 */
	handleCompanyTypeFieldVisibility() {
		const show = 'Refrigeration engineer' === this.companyTypeField.value;
		
		this.engineerFields.forEach( field => field.hidden = !show );
	}

	/**
	 * Set visibility when the Order Sample Box field changes.
	 */
	handleSampleBoxFieldVisibility() {
		const show = 'Refrigeration engineer' === this.companyTypeField.value && this.sampleBoxField.checked;
		
		this.sampleBoxFields.forEach( field => field.hidden = !show );
	}
}

document.querySelectorAll( '.whippet-wholesale-register' ).forEach( form => {
	new WholesaleRegistration( form );
} );
